import { Box, Typography } from "@mui/material"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import theme from "src/theme/light"

export interface PremissasGeracaoProps {
    geracao_total: number | any;
    consumo_total: number | any;
  }
export function PremissasGeracao({ geracao_total = 0, consumo_total = 0 }: PremissasGeracaoProps){
    return (
      <Box>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            <strong style={{ color: theme.palette.primary.main }}>Geração Solar Total: </strong> 
            de acordo com as informações adicionadas no projeto a geração anual estimada* será de aproximadamente {Number(Number(geracao_total).toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} kWh/ano.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            <strong style={{ color: theme.palette.primary.main }}>Consumo Total: </strong> 
            de acordo com as informações adicionadas no projeto o consumo atual durante o período de um ano é de {Number(Number(consumo_total).toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} kWh/ano.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * A geração é calculada considerando que os painéis solares serão instalados com inclinação ideal, voltados para a direção norte, sem sombreamento e com a manutenção adequada (Limpeza, etc), conforme Manual do Produto.
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Esses valores são de referência e podem variar considerando as condições climáticas do local (conforme indicado no manual do módulo).
        </Typography>
        <Typography style={{fontSize: "14px", paddingLeft: "10px"}}>
            * Valores de HSP (Horas de Sol Pico) com base no banco de dados do INPE (2006).
        </Typography>
      </Box>
    )
  }